export default __webpack_public_path__ + "static/media/explore-iv-banner-2@3x.351117e9.png";